export const GeneralInfoOptions = {

};
